import { Card, CardContent, CardFooter, CardHeader, Division } from "@ir/ui";
import type { ReactNode } from "react";
import type { Organization } from "@src/domain/entities/organization/Organization";
import { OrganizationCardHeader } from "./OrganizationCardHeader";
import { OrganizationCardFooter } from "./OrganizationCardFooter";

export interface OrganizationCardProps {
  organization: Organization;
  children: ReactNode;
  showFooter?: boolean;
}

export const OrganizationCard = ({
  organization,
  children,
  showFooter = false,
}: OrganizationCardProps) => {
  return (
    <Division className="mb-4 organization-card-container">
      <Card className="bg-white" variant="outlined" shadow>
        <CardHeader className="border-bottom-1 border-color-grey-50">
          <OrganizationCardHeader organization={organization} />
        </CardHeader>
        <CardContent>{children}</CardContent>
        {showFooter && (
          <CardFooter>
            <OrganizationCardFooter organization={organization} />
          </CardFooter>
        )}
      </Card>
    </Division>
  );
};
